import Header from "../layout/header";
import ActivityLog from "../features/branch/components/ActivityLog";

function TecfolkActivityPage() {
  return (
    <div className="main">
      <Header />
      <ActivityLog variant="tecfolk" />
    </div>
  );
}

export default TecfolkActivityPage;
